import { render, staticRenderFns } from "./MensageriaConsulta.vue?vue&type=template&id=409e5330&scoped=true"
import script from "./MensageriaConsulta.vue?vue&type=script&lang=js"
export * from "./MensageriaConsulta.vue?vue&type=script&lang=js"
import style0 from "./MensageriaConsulta.vue?vue&type=style&index=0&id=409e5330&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "409e5330",
  null
  
)

export default component.exports